import { render, staticRenderFns } from "./CommonChart.vue?vue&type=template&id=bf0acb40&scoped=true"
import script from "./CommonChart.vue?vue&type=script&lang=js"
export * from "./CommonChart.vue?vue&type=script&lang=js"
import style0 from "./CommonChart.vue?vue&type=style&index=0&id=bf0acb40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0acb40",
  null
  
)

export default component.exports